/**
 * KeepToolCard — carte Google Keep dans le Bureau cockpit.
 *
 * Batch #14.32 — Si keep_manual_url configuré → ouvre directement.
 * Sinon → bouton "Ouvrir Keep filtré" + bouton "Lier un lien Keep".
 *
 * Extrait de Bureau.jsx (Batch #14.221).
 */
import { useState } from "react";
import { StickyNote, ExternalLink, Link2 } from "lucide-react";
import WorkspaceLinkForm from "./WorkspaceLinkForm";

export default function KeepToolCard({ hub, masterId, expertise, onLinked }) {
  const keep = hub?.keep || {};
  const [editing, setEditing] = useState(false);

  if (keep.manual_url) {
    return (
      <div className="border border-amber-200 hover:border-amber-400 rounded-xl p-4 bg-white hover:shadow-md min-h-[140px] transition" data-testid="bureau-keep">
        <div className="flex items-start justify-between">
          <StickyNote className="w-6 h-6 text-amber-600" />
          <button
            onClick={() => setEditing(true)}
            className="text-[10px] text-slate-400 hover:text-amber-600 inline-flex items-center gap-0.5"
            data-testid="bureau-keep-edit-btn"
          >
            <Link2 className="w-3 h-3" /> Modifier
          </button>
        </div>
        <div className="font-semibold text-sm text-slate-800 mt-3">Google Keep</div>
        <div className="text-[11px] text-slate-500 mt-0.5 truncate">Lien personnalisé</div>
        <a
          href={keep.manual_url}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 inline-flex items-center gap-1 text-[12px] font-medium text-amber-600 hover:text-amber-800"
          data-testid="bureau-keep-open-link"
        >
          <ExternalLink className="w-3.5 h-3.5" /> Ouvrir Keep
        </a>
        {editing && (
          <WorkspaceLinkForm
            tool="keep"
            masterId={masterId}
            expertise={expertise}
            initialUrl={keep.manual_url}
            placeholder="https://keep.google.com/#label/..."
            tip="Créez un libellé dans Keep pour ce client, puis copiez l'URL ici."
            onCancel={() => setEditing(false)}
            onSaved={() => { setEditing(false); onLinked?.(); }}
          />
        )}
      </div>
    );
  }

  return (
    <div
      className="border border-amber-200 hover:border-amber-400 rounded-xl p-4 bg-white hover:shadow-md min-h-[140px] transition"
      data-testid="bureau-keep"
    >
      <StickyNote className="w-6 h-6 text-amber-600" />
      <div className="font-semibold text-sm text-slate-800 mt-3">Google Keep</div>
      <div className="text-[11px] text-slate-500 mt-0.5 truncate">
        Recherche filtrée par client
      </div>
      {!editing ? (
        <div className="mt-2 flex items-center gap-1.5 flex-wrap">
          <a
            href={keep.quick_link}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-[12px] font-medium text-amber-600 hover:text-amber-800"
            data-testid="bureau-keep-open-default"
          >
            <ExternalLink className="w-3.5 h-3.5" /> Ouvrir Keep filtré
          </a>
          <button
            onClick={() => setEditing(true)}
            className="ml-1 text-[11px] text-amber-600 hover:text-amber-800 inline-flex items-center gap-0.5"
            data-testid="bureau-keep-link-btn"
          >
            <Link2 className="w-3 h-3" /> Lier un lien
          </button>
        </div>
      ) : (
        <WorkspaceLinkForm
          tool="keep"
          masterId={masterId}
          expertise={expertise}
          initialUrl=""
          placeholder="https://keep.google.com/#label/..."
          tip="Créez un libellé dans Keep pour ce client, puis copiez l'URL ici."
          onCancel={() => setEditing(false)}
          onSaved={() => { setEditing(false); onLinked?.(); }}
        />
      )}
    </div>
  );
}
